(function (angular) {
    'use strict';

    angular.module('templates')
        .controller('templatesCtrl', ['$scope', "$uibModal", "profileSchema", "templateService", "$stateParams", "growlService", "templatesData", "sweetAlertService",
            function ($scope, $uibModal, profileSchema, templateService, $stateParams, growlService, templatesData, sweetAlertService) {
                $scope.templatesData = templatesData;
                $scope.profileSchema = profileSchema;

                $scope.createTemplate = function () {
                    return openTemplatesModal();
                }

                $scope.editTemplate = function (template) {
                    return openTemplatesModal(template);
                }

                function openTemplatesModal(template) {

                    var modalInstance = $uibModal.open({
                        templateUrl: 'components/messageTemplates/templates/templateModal.html',
                        controller: 'templateModal',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            template: function () {
                                return template;
                            },
                            profileSchema: function () {
                                return $scope.profileSchema;
                            },
                            templatesData: function () {
                                return $scope.templatesData;
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        if (data.id) {
                            return templateService.updateTemplate($stateParams.pickedApiSpaceId, data)
                                .then(function (result) {
                                    growlService.success('Template updated');
                                    var index = $scope.templatesData.indexOf(template);
                                    $scope.templatesData[index] = result;
                                    return result;
                                }).catch(function (error) {
                                    growlService.danger("Template wasn't updated due to: " + error.statusText);
                                });

                        } else {
                            return templateService.createTemplate($stateParams.pickedApiSpaceId, data)
                                .then(function (result) {
                                    growlService.success('Template created');
                                    $scope.templatesData.push(result);
                                    return result;
                                }).catch(function (error) {
                                    growlService.danger("Template wasn't created due to: " + error.statusText);
                                });
                        }
                    }, function () {
                        // $log.info('Modal dismissed at: ' + new Date());
                    });

                }

                $scope.deleteTemplate = function (template) {
                    sweetAlertService.confirmationAlert(
                        "Are you sure?",
                        "Are you sure you want to remove " + template.name + "?",
                        "Remove",
                        "Cancel",
                        function (isConfirmed) {
                            if (isConfirmed) {
                                templateService.deleteTemplate($stateParams.pickedApiSpaceId, template.id).then(function (ret) {
                                    growlService.success('Template deleted');
                                    var index = $scope.templatesData.indexOf(template);
                                    $scope.templatesData.splice(index, 1);
                                }).catch(function (error) {
                                    growlService.danger("Template wasn't deleted due to: " + error.statusText);
                                });
                            }
                        }
                    );
                };

                $scope.viewTemplate = function (template) {
                    return previewTemplatesModal(template);
                }
                function previewTemplatesModal(template) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'components/messageTemplates/templates/previewTemplateModal.html',
                        controller: 'previewTemplateModal',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            template: function () {
                                return template;
                            },
                        }
                    });

                    modalInstance.result.then(function (data) {
                    }, function () {
                        // $log.info('Modal dismissed at: ' + new Date());
                    });
                }
            }]);

})(window.angular);
